import { render, staticRenderFns } from "./OrderRequestUserSearchDashboard.vue?vue&type=template&id=da580c08&scoped=true&"
import script from "./OrderRequestUserSearchDashboard.vue?vue&type=script&lang=js&"
export * from "./OrderRequestUserSearchDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrderRequestUserSearchDashboard.vue?vue&type=style&index=0&id=da580c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da580c08",
  null
  
)

export default component.exports